const AR_MAGIC = "!<arch>\n";

function isLibraryFilename(name: string): boolean {
  const n = name.toLowerCase();
  return n.endsWith(".lib") || n.endsWith(".a");
}

function isLikelySymbolName(s: string): boolean {
  if (s.length < 2 || s.length > 256) return false;
  if (/^[0-9]+$/.test(s)) return false;
  if (/^(?:__.?SYMDEF|\/\/|\/|`|ar|ranlib)$/i.test(s)) return false;
  if (!/[_A-Za-z?$@.]/.test(s)) return false;
  return true;
}

function extractSymbolCandidates(bytes: Uint8Array): string[] {
  const text = new TextDecoder("latin1").decode(bytes);
  const raw = text.match(/[?_A-Za-z@$][A-Za-z0-9_?$@.:~<>-]*/g) ?? [];
  const out: string[] = [];
  const seen = new Set<string>();
  for (const s of raw) {
    if (!isLikelySymbolName(s)) continue;
    if (seen.has(s)) continue;
    seen.add(s);
    out.push(s);
    if (out.length >= 4000) break;
  }
  return out;
}

export async function renderLibraryNmPreview(file: File): Promise<string | null> {
  return renderLinuxObjectPreview(file, false);
}

export async function renderLinuxObjectPreview(file: File, force: boolean): Promise<string | null> {
  if (!force && !isLibraryFilename(file.name)) return null;
  const bytes = new Uint8Array(await file.arrayBuffer());
  const hdr = new TextDecoder("ascii").decode(bytes.slice(0, 8));
  if (hdr !== AR_MAGIC) {
    return [
      `# ${file.name}`,
      "",
      "Not an ar archive; raw binary preview is not supported in this editor.",
      "Tip: run `nm <file>` in terminal for native symbol inspection.",
    ].join("\n");
  }
  const symbols = extractSymbolCandidates(bytes);
  const lines = [
    `# nm-style view: ${file.name}`,
    `# extracted symbols: ${symbols.length}`,
    "# note: browser fallback parser (best effort)",
    "",
  ];
  if (!symbols.length) {
    lines.push("(no symbols extracted)");
  } else {
    for (const sym of symbols.sort((a, b) => a.localeCompare(b))) {
      lines.push(`U ${sym}`);
    }
  }
  return lines.join("\n");
}
